import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none",
  viewBox: "0 0 15 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#F05033",
    d: "M8.438 1.432c0-.93-1.198-1.28-1.725-.51C1.875 7.995 8.75 8.313 8.75 11.75a2.5 2.5 0 0 1-2.533 2.5c-1.374-.018-2.467-1.163-2.467-2.537v-3.34c0-.848-1.034-1.26-1.618-.645C1.086 8.827 0 10.708 0 13c0 4.136 3.364 7.5 7.5 7.5S15 17.136 15 13c0-6.652-6.563-7.539-6.563-11.568Z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 .5h15v20H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }